import { Card, Button, Typography } from "antd";
import { InfoOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const { Title, Text } = Typography;

const JobPostingCard = ({ job, onInfoClick, onCardClick }) => {
  const { title, description, employmentType, availableSlots, slotsFilled, status, createdAt } = job;

  const timeAgo = createdAt ? dayjs(createdAt).fromNow() : "Recently Posted";

  return (
    <Card className="rounded-2xl shadow-xl w-100 h-full flex flex-col justify-between cursor-pointer" onClick={onCardClick}>
      <div className="flex justify-end ">
        <Button
          type="primary"
          shape="circle"
          className="p-0 m-0"
          icon={<InfoOutlined />}
          style={{ backgroundColor: "#FF7201", border: "#F45F0B", height: "30px" }}
          onClick={(e) => {
            e.stopPropagation();
            onInfoClick(job);
          }}
        />
      </div>
      <div className="px-3 pb-4">
        <Text className="text-[#FF7F50] text-md font-medium">Posted {timeAgo}</Text>
        <Title level={3} style={{ padding: 0, marginTop: 1, marginBottom: 6 }} className="text-4xl font-extrabold m-0 p-0 line-clamp-1">
          {title}
        </Title>
        <div className="job-description-content text-md text-gray-600 line-clamp-2" dangerouslySetInnerHTML={{ __html: description }} />

        <div
          className="mt-4 inline-flex items-center justify-center rounded-full px-6 py-1 font-bold text-lg"
          style={{
            backgroundColor: "#FFB77D",
            color: "#F45F0B",
            width: "fit-content",
          }}
        >
          {employmentType === "ProjectBased" ? "Project-Based" : employmentType}
        </div>

        <div className="flex justify-between items-center mt-4">
          <div className="flex items-center gap-1">
            <Text className=" text-[#F45F0B] text-2xl font-bold leading-none">
              {slotsFilled}/{availableSlots}
            </Text>
            <p className="text-[#F45F0B] text-sm font-normal m-0 p-0">Applied for this job</p>
          </div>
          {status === "Closed" ? <div className=" py-2 px-4  bg-[#FF0000] rounded-xl text-white font-bold">CLOSED</div> : null}
        </div>
      </div>
    </Card>
  );
};

JobPostingCard.propTypes = {
  job: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    employmentType: PropTypes.string,
    status: PropTypes.string,
    availableSlots: PropTypes.number,
    slotsFilled: PropTypes.number,
    createdAt: PropTypes.string,
  }).isRequired,
  onInfoClick: PropTypes.func.isRequired,
  onCardClick: PropTypes.func.isRequired,
};

export default JobPostingCard;
